/**
 * Users
 */

// React
import React, { FunctionComponent, useEffect, useState, useContext } from 'react';

// Context
import AuthContext from '../../authContext';

// Redux
import { Link } from 'react-router-dom';

// Components
import Pagination from '@material-ui/lab/Pagination';
import List from './components/list';
import EXCEL from './components/excel';
import Can from '../../components/Can';

// UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  Typography,
  CircularProgress,
  Button,
  Dialog,
  DialogActions,
  Grid,
  DialogTitle,
  FormControl,
  Select,
  MenuItem,
  IconButton,
  Card,
  CardHeader,
  CardContent,
  Paper,
  Divider,
} from '@material-ui/core';

// Helper
import { removeEmptyValueObject, checkMatchMedia } from '../../utils/helpers';
import useQuery from '../../utils/hook/useQuery';

// Type
import { Props } from './interfaces';
import type { Filter } from '../../utils/listDaynamicFilter';
import { Active, Inactive } from './customIcon';
import handleError from '../../utils/handleError';
import centersRepository from 'client-sdk/src/Repository/centers-repository';
import handleNotfication from '../../utils/handleNotfication';
import TicketLink from '../../components/ticketLink';
import RonadIcons from '../../components/iconComponent';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    paper: {},
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    textArea: {
      width: '100%',
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      padding: '10px 0',
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    input: {
      display: 'flex',
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    cards: {
      position: 'relative',
      backgroundColor: 'white',
      padding: '14px',
    },
    boxshadow: {
      position: 'relative',
      backgroundColor: 'white',
      padding: '14px',
      transform: 'translateY(-3px)',
      boxShadow: '-4px 4px 12px 0px rgba(0,0,0,0.15) !important',
    },
    iconHeader: {
      position: 'absolute',
      top: '5px',
      right: '5px',
    },
    cardContent: {
      marginTop: '-20px',
      display: 'flex',
    },
    hover: {
      '&:hover': {
        curser: 'pointer',
      },
    },
    chart: {
      padding: '24px',
      height: '312px',
      backgroundColor: 'white',
      width: '100%',
      overflow: 'visible',
    },
    progress: {
      padding: '24px',
      height: '312px',
      backgroundColor: 'white',
      width: '100%',
      overflow: 'visible',
    },
    typographyCards: {
      fontSize: '16px',
      color: 'white',
      backgroundColor: '#4BCF90',
      paddingTop: '8px',
      paddingRight: '24px',
      paddingBottom: '8px',
      paddingLeft: '50px',
      marginLeft: '-35px',
    },
    iconButton: {
      padding: 8,
      marginRight: '10px',
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      marginTop: '30px',
      top: '47px',
      right: 0,
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    allCenter: {
      position: 'relative',
      marginRight: '30px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#B297A7',
      },
    },
    activeCenter: {
      position: 'relative',
      marginRight: '30px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#039590',
      },
    },
    diactiveCenter: {
      position: 'relative',
      marginRight: '30px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#ddd',
      },
    },
    checkIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: '#039590',
      },
    },
    title: {
      display: 'flex',
      alignItems: 'center',
      color: '#8A8A8A',
      fontSize: '16px',
      fontWeight: 500,
      marginRight: '8px',
    },
    text: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '21px',
      fontWeight: 500,
    },
    showCount: {
      '& .MuiSelect-icon': {
        color: '#DFA01F',
      },
    },
    btnBox: {
      marginTop: '5px',
      padding: '10px',
      display: 'flex',
      flexDirection: 'row-reverse',
      width: '100%',
      '@media (max-width: 768px)': {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
      },
    },
    headerBox: {
      marginLeft: '75px',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
      marginTop: '10px',
    },
    cardContentOrder: {
      padding: '0',
    },
    cardContentlist: {
      justifyContent: 'space-between',
      padding: ' 0',
    },
    card: {
      width: '100%',
      marginBottom: '14px',
      overflow: 'visible',
      padding: '14px 0 0',
      paddingBottom: '0',
    },
    cancelTitle: {
      marginTop: '45px',
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      marginBottom: theme.spacing(1),
    },
  })
);

const Centers: FunctionComponent<Props> = (props: Props) => {
  const authContext = useContext(AuthContext);
  const { partnerId, warehousesId } = props.match.params;
  const [filters, setFilters] = useState([] as Filter[]);
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [centersList, setCentersList] = useState([])
  const [centersCount, setCentersCount] = useState(0)
  const { filtersValues, setFiltersValues } = useQuery({
    page: 0,
    size: 10,
  });
  const [centersReport, setCentersReport] = useState([])
  const [openConfirmDisable, setOpenConfirmDisable] = useState(
    false as boolean
  );
  const [loading, setLoading] = useState(false)
  const [openConfirmActive, setOpenConfirmActive] = useState(false as boolean);
  const [id, setId] = useState(-1 as number);

  useEffect(() => {
    getCenters();
    setupFilters();
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps
  const classes = useStyles();

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  const getCenters = async () => {
    setLoading(true)
    const { page, size } = filtersValues;
    const payload = {
      ...removeEmptyValueObject(filtersValues),
      warehousesId: { equals: warehousesId },
      partnerId: { equals: partnerId },
      page,
      size,
    }
    try {
      const { response, count } = await centersRepository.getCenters({ payload })
      setCentersList(response.data)
      setCentersCount(count.data)
      setLoading(false)
    } catch (error) {
      handleError(error)
    }
  };

  const setupFilters = () => {
    setFilters([
      {
        type: 'input',
        id: 'name.contains',
        label: 'نام مرکز',
      },
      {
        type: 'input',
        id: 'province.contains',
        label: 'استان',
      },
      {
        type: 'input',
        id: 'city.contains',
        label: 'شهر',
      },
      {
        type: 'input',
        id: 'phoneNumber.contains',
        label: 'تلفن مرکز',
      },
      {
        type: 'checkbox',
        id: 'status.in',
        label: 'وضعیت ',
        data: ['ACTIVE', 'SUSPENDED'],
        translateType: 'CenterStatus',
      },
    ]);
  };

  const handleCloseSelect = () => {
    setOpenSize(false);
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };

  const handleDisableCenter = async () => {
    try {
      await centersRepository.updateCenterStatus({
        payload: {
          body: 'SUSPENDED',
          pagination: { ...filtersValues, partnerId: { equals: partnerId } },
          id,
        }
      })
      handleNotfication("مرکز با موفقیت غیرفعال شد", "success")
    } catch (error) {
      handleError(error)
    }
    setOpenConfirmDisable(false);
    getCenters()
  };

  const handleActiveCenter = async () => {
    try {
      await centersRepository.updateCenterStatus({
        payload: {
          body: 'ACTIVE',
          pagination: { ...filtersValues, partnerId: { equals: partnerId } },
          id,
        }
      })
      handleNotfication("مرکز با موفقیت فعال شد", "success")
    } catch (error) {
      handleError(error)
    }
    setOpenConfirmActive(false);
    getCenters()
  };

  const handleOpenConfirmDisable = (centerId: number) => {
    setOpenConfirmDisable(true);
    setId(centerId);
  };

  const handleOpenConfirmActive = (centerId: number) => {
    setOpenConfirmActive(true);
    setId(centerId);
  };
  const handleOpen = (id: number, type: string) => {
    setId(id);
  };

  const handleClose = () => {
    setOpenConfirmDisable(false);
    setOpenConfirmActive(false);
  };

  const handleOpenConfirmUpdateState = (data: { id: number; body: any }) => {
    setId(data.id);
  };

  const handleCardClose = (id: any) => {
    const { page, size } = filtersValues;
    delete filtersValues['status.in'];
    setFiltersValues({
      ...removeEmptyValueObject(filtersValues),

      page: 0,
      size: 10,
    });
  };

  const handleCardClick = (name: string) => {
    const { page, size } = filtersValues;

    switch (name) {
      case 'active':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['ACTIVE'],
          page: 0,
          size: 10,
        });
        break;
      case 'inactive':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['SUSPENDED'],
          page: 0,
          size: 10,
        });
        break;
    }
  };

  const checkActiveCard = (name: string) => {
    const status = filtersValues['status.in']?.split(',') || [];
    switch (name) {
      case 'active':
        return status.includes('ACTIVE');
      case 'inactive':
        return status.includes('SUSPENDED');
    }
  };

  const getAllcentersReport = async (payload: any) => {
    try {
      const response = await centersRepository.getAllCentersReport({ payload });
      setCentersReport(response.data)
    } catch (error) {
      handleError(error)
    }
  }
  return (
    <div className={classes.root}>
      {/* <Grid
        style={{
          zIndex: 3,
          backgroundColor: 'white',
          position: 'fixed',
          top: '0',
          right: '71px',
        }}
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Paper
          elevation={1}
          style={{
            padding: '5px 2px',
            width: '100%',
            borderRadius: '0',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div className={classes.headerBox}>
            
          </div>
          <div
            style={{
              marginLeft: '140px',
              display: 'flex'
            }}
          >
            <RenderFilter
              filters={filters}
              onFilter={(filtervalues: any) => {
                setFiltersValues({
                  ...removeEmptyValueObject(filtervalues),
                  page: 0,
                  size: 10,
                });
              }}
              mainFiltersCount={0}
              baseFilter={{
                type: 'input',
                id: 'centerName.equals',
                placeholder: 'نام مرکز',
              }}
              filterValues={filtersValues}
            />
            <TicketLink />
          </div>
        </Paper>
      </Grid> */}
      <Typography variant="h6" component="h2">
        {`مدیریت مراکز`}
      </Typography>
      <Grid container spacing={1}>
        <Grid
          container
          spacing={2}
          md={12}
          style={{
            maxWidth: '120%',
            margin: '24px 0',
          }}
        >
          <Grid
            container
            lg={12}
            spacing={1}
            xs={12}
            style={{ marginRight: '2px' }}
          >
            <Grid item md={6} lg={6} xs={12}>
              <Card
                className={
                  checkActiveCard('active') ? classes.boxshadow : classes.cards
                }
              >
                <CardHeader
                  action={
                    checkActiveCard('active') && (
                      <IconButton
                        aria-label="close"
                        onClick={handleCardClose}
                        className={classes.iconHeader}
                      >
                        <RonadIcons name="times" className='pointer text-danger'  size={0.8}/>
                      </IconButton>
                    )
                  }
                />
                <CardContent className={classes.cardContent}>
                  <IconButton
                    type="submit"
                    onClick={name => handleCardClick('active')}
                    aria-label="search"
                    style={{
                      backgroundColor: '#D6EBD3',
                      // height: '30%',
                      // width: '28%',
                      borderRadius: '4px',
                      margin: '-20px 0',
                    }}
                  >
                    <Active />
                  </IconButton>
                  <Grid
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      marginRight: '10px',
                    }}
                  >
                    <Typography
                      variant="h6"
                      component="h6"
                      style={{ fontWeight: 600, marginTop: '-20px' }}
                    >
                      {/* {props.countActive} */}
                    </Typography>
                    <Typography
                      style={{
                        fontSize: '16px',
                        marginBottom: '-20px',
                        fontWeight: 550,
                        color: '#666666',
                      }}
                    >
                      مرکز فعال
                    </Typography>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item md={6} lg={6} xs={12}>
              <Card
                className={
                  checkActiveCard('inactive')
                    ? classes.boxshadow
                    : classes.cards
                }
              >
                <CardHeader
                  action={
                    checkActiveCard('inactive') && (
                      <IconButton
                        aria-label="close"
                        onClick={handleCardClose}
                        className={classes.iconHeader}
                      >
                        <RonadIcons name="times" className='pointer text-danger'  size={0.8}/>
                      </IconButton>
                    )
                  }
                />
                <CardContent className={classes.cardContent}>
                  <IconButton
                    type="submit"
                    aria-label="search"
                    onClick={name => handleCardClick('inactive')}
                    style={{
                      backgroundColor: '#FCD4DA',
                      borderRadius: '4px',
                      margin: '-20px 0',
                    }}
                  >
                    <Inactive />
                  </IconButton>
                  <Grid
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      marginRight: '10px',
                    }}
                  >
                    <Typography
                      variant="h6"
                      component="h6"
                      style={{ fontWeight: 600, marginTop: '-20px' }}
                    >
                      {/* {props.countDeactive} */}
                    </Typography>
                    <Typography
                      style={{
                        fontSize: '16px',
                        marginBottom: '-20px',
                        fontWeight: 550,
                        color: '#666666',
                      }}
                    >
                      مرکز غیرفعال
                    </Typography>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Grid>
        <Grid container item spacing={1}>
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Grid>
                  <Typography className={classes.typographyCards}>
                    لیست مراکز
                  </Typography>
                </Grid>
              }
              action={
                <div className={classes.btnBox}>
                  <Can
                    role={authContext.user.role}
                    perform="centers:createNewCenter"
                    yes={() => (
                      <Link to={`/centeradd`}>
                        {/* <IconButton
                          aria-label="add"
                          size="medium"
                          title="ایجاد"
                          data-cy="add"
                        > */}
                        <Button
                          size={
                            checkMatchMedia('(max-width: 1024px)')
                              ? 'small'
                              : 'large'
                          }
                          variant="contained"
                          color="primary"
                          style={{
                            textDecoration: 'none',
                          }}
                          endIcon={<RonadIcons name='plus' className='text-white' size={0.7}/>}
                        >
                          {`ایجاد مرکز `}
                        </Button>
                        {/* </IconButton> */}
                      </Link>
                    )}
                  />
                  <Can
                    role={authContext.user.role}
                    perform="centers:downloadReportCSV"
                    yes={() => (
                      <EXCEL
                        getData={getAllcentersReport}
                        data={centersReport}
                        id={partnerId}
                        filtersValues={filtersValues}
                        loading={loading}
                      />
                    )}
                  />
                </div>
              }
            />

            <CardContent className={classes.cardContentOrder}>
              <Grid
                container
                lg={12}
                md={12}
                className={classes.cardContentlist}
              >
                <Grid container item lg={12} md={12}>
                  <Grid
                    container
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    alignItems="center"
                  >
                    {loading ? (
                      <div className={classes.loading}>
                        <CircularProgress />
                      </div>
                    ) : (
                      <List
                        data={centersList}
                        handleOpenConfirmDisable={handleOpenConfirmDisable}
                        handleOpenConfirmActive={handleOpenConfirmActive}
                        handleOpen={handleOpen}
                        partnerId={partnerId}
                        warehousesId={warehousesId}
                        changeStatus={handleOpenConfirmUpdateState}
                      />
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    style={{ padding: '20px 10px 0 10px' }}
                  >
                    {centersList.length > 0 && (
                      <FormControl
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                        }}
                      >
                        <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                          {' '}
                          تعداد نمایش در هر صفحه:
                        </div>
                        <Select
                          open={openSize}
                          onClose={handleCloseSelect}
                          className={classes.showCount}
                          onOpen={() => setOpenSize(true)}
                          value={filtersValues.size}
                          onChange={handleChangeSizePage}
                        >
                          <MenuItem value={10}>10</MenuItem>
                          <MenuItem value={20}>20</MenuItem>
                          <MenuItem value={50}>50</MenuItem>
                          <MenuItem value={100}>100</MenuItem>
                        </Select>
                      </FormControl>
                    )}
                  </Grid>
                  <Grid
                    xs={12}
                    sm={6}
                    container
                    item
                    direction="row-reverse"
                    style={{ padding: '20px 10px 0 10px' }}
                  >
                    {centersList.length > 0 && (
                      <Pagination
                        className={classes.pagination}
                        count={Math.ceil(centersCount / filtersValues.size)}
                        color="secondary"
                        page={filtersValues.page + 1}
                        onChange={handleChangePage}
                      />
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Dialog
        open={openConfirmDisable || openConfirmActive}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton aria-label="close" onClick={handleClose}>
                <RonadIcons name="times"  size={0.8}/>
              </IconButton>
            ) : null}
          </div>
          <div className={classes.cancelTitle}>
            {` آیا از
           ${openConfirmDisable ? 'غیر' : ''}
           
           
           فعال کردن شرکت با نام
          "${centersList?.find(center => center.id === id)?.name}"
          اطمینان دارید؟`}
          </div>
          <Divider style={{ width: '100%', margin: '16px 0  0' }} />
        </DialogTitle>
        <DialogActions>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            style={{ textAlign: 'center', marginBottom: '8px' }}
          >
            <Grid item xs={12}>
              <Button
                style={{ marginLeft: '8px' }}
                autoFocus
                onClick={handleClose}
                variant="contained"
                color="primary"
              >
                {`انصراف`}
              </Button>
              {openConfirmDisable ? (
                <Button
                  onClick={handleDisableCenter}
                  variant="outlined"
                  color="primary"
                >
                  {`غیرفعال کردن`}
                </Button>
              ) : (
                <Button
                  onClick={handleActiveCenter}
                  variant="outlined"
                  color="primary"
                >
                  {`فعال کردن`}
                </Button>
              )}
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Centers;
